export function translateCognitoError(error: unknown): string {
    const err = error as {name?: string; code?: string; message?: string};
    const code = err?.name ?? err?.code ?? '';
    const msg = err?.message ?? '';

    const map: Record<string, string> = {
        NotAuthorizedException: 'Credenciales incorrectas',
        UserNotFoundException: 'Usuario no encontrado',
        UserNotConfirmedException: 'Usuario no verificado. Revisa tu email.',
        PasswordResetRequiredException: 'Debes restablecer tu contrasena',
        LimitExceededException: 'Demasiados intentos. Espera un momento.',
        TooManyFailedAttemptsException: 'Cuenta bloqueada temporalmente. Intenta mas tarde.',
        CodeMismatchException: 'Codigo incorrecto',
        ExpiredCodeException: 'El codigo ha expirado. Solicita uno nuevo.',
        InvalidPasswordException: 'La contrasena no cumple los requisitos',
        InvalidParameterException: msg.includes('password')
            ? 'La contrasena no cumple los requisitos'
            : msg || 'Parametro invalido',
        SoftwareTokenMFACodeMismatchException: 'Codigo MFA incorrecto',
        EmptySignInResponseException: 'Error de comunicacion con el servidor. Intenta de nuevo.',
        NetworkError: 'Error de conexion. Verifica tu internet.',
    };

    return map[code] ?? (msg || 'Error desconocido. Intenta de nuevo.');
}
